import { useQuery } from '@apollo/client';
import { useCountry } from '../../components/CountrySelector';
import {
  GET_RETURN_SUMMARY_QUERY,
  GetReturnSummaryQuery,
  GetReturnSummaryQueryVariables
} from './returnSummary.rest';

type UseReturnSummaryArgs = {
  shipmentNumber?: string;
  orderNumber?: string;
};

export const useReturnSummary = ({ shipmentNumber, orderNumber }: UseReturnSummaryArgs) => {
  const { country } = useCountry();
  const { data, loading, error } = useQuery<GetReturnSummaryQuery, GetReturnSummaryQueryVariables>(
    GET_RETURN_SUMMARY_QUERY,
    { variables: { shipmentNumber, orderNumber, countryCode: country.alpha2Code } }
  );

  return {
    returnSummary: data?.getReturnSummary.data[0],
    loading,
    error
  };
};
